import { useParams } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { formatValidityDate } from "utils/document-utils";
import { configService } from "services/configService";
import { permitteesService } from "services/permitteesService";
import { documentsPermitteesService } from "services/documentsPermitteesService";

const PermitteesDocumentsValidate = () => {
    const { code } = useParams();
    const { t } = useTranslation();
    const [config, setConfig] = useState(undefined);
    const [html, setHtml] = useState(undefined);

    useEffect(async () => {
        const data = await permitteesService.fetchDocumentsByCodeList([code]);
        const transportPermissionDocument = await documentsPermitteesService.find(data[0].id);
        const config = await configService.get();
        setConfig(config);
        setHtml(`
            <!DOCTYPE html>
            <html lang="pt-BR">
            <head>
                <meta charset="UTF-8">
                <title>GOTT - Gestor de Operações de Trânsito e Transporte</title>
                <style>
                    .header {
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        justify-content: center;
                        text-align: center;
                        margin: 0;
                        font-family: Arial, sans-serif;
                        max-width: 800px;
                    }
                    img {
                        margin: auto;
                        margin-top: 20px;
                    }
                    .text-center {
                        margin: 40px;
                    }
                    .text-center p {
                        margin: 4px 0;
                    }
                    .document-info {
                        margin: 40px;
                    }
                    .document-info p {
                        margin: 4px 0;
                    }
                </style>
            </head>
                <body>
                    <div class="header">
                        <img src="/assets/logos/${config.company_logo}" width="200" alt="Logo"/>
                        <div class="text-center">
                            <p><strong>${config.company_state_description}</strong></p>
                            <p><strong>${config.company_owner_name}</strong></p>
                            <p><strong>${config.company_name}</strong></p>
                        </div>
                        <p><strong>${t("permittees.documents.validate.title")}</strong></p>
                    </div>
                    <div class="document-info">
                        ${data.length > 0 ? (
                            `
                            <p><strong>
                            ${t("permittees.documents.validate.fields.owner")}: </strong>${data[0].nome_proprietario}
                            </p>
                            <p><strong>
                            ${t("permittees.documents.validate.fields.plate")}: </strong>${data[0].placa_veiculo}
                            </p>
                            <p><strong>
                            ${t("permittees.documents.validate.fields.vehicle")}: </strong>${data[0].transport_permission.veiculo.descricao_marca_modelo}
                            </p>
                            <p><strong>
                            ${t("permittees.documents.validate.fields.cpf")}: </strong>1${data[0].cpf_cnpj_proprietario}
                            </p>
                            <p><strong>
                            ${t("permittees.documents.validate.fields.stand")}: </strong>${data[0].transport_permission_location.numero} - ${data[0].transport_permission_location.logradouro}
                            </p>
                            <p><strong>
                            ${t("permittees.documents.validate.fields.spot")}: </strong>${data[0].permission_numero}
                            </p>
                            <p><strong>
                            ${t("permittees.documents.validate.fields.validity")}: </strong>${formatValidityDate(transportPermissionDocument.data_validade)}
                            </p>
                            `
                        ) : (
                            `<p>${t("permittees.documents.validate.messages.errors.document-not-found")}</p>`
                        )}
                    </div>
                </body>
            </html>
        `);
    }, []);


    return (
        <>
        {config && html && (
            <div dangerouslySetInnerHTML={{ __html: html }} />
        )}
        </>
    );
};

export default PermitteesDocumentsValidate;